export default __webpack_public_path__ + "static/media/head-icon.97f08fa8.svg";